import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Label,
  Input,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalRequireLogin = ({ linkRequireLogin, handleChange }) => {
  const intl = useIntl();

  return (
    <div className="share-require-login share-setting">
      <Label for="inpRequireLogin" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Require workspace login' })}
          <HelpIcon id="share-require-login">
            {intl.formatMessage({ defaultMessage: 'Require all recipients to be logged into this workspace to access this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-require-login" simple={true} />
          {userHasFeature('share-require-login') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="requireLogin"
                id="inpRequireLogin"
                value={true}
                checked={linkRequireLogin}
                onChange={handleChange}
                disabled={!canUserManageShare()}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
    </div>
  );
};

ShareModalRequireLogin.propTypes = {
  linkRequireLogin: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalRequireLogin;
